// Load Quest configuration from server-rendered JSON
// This sets up window globals needed by legacy code

export function loadQuestConfig() {
  const configElement = document.getElementById('quest-config');

  if (!configElement) {
    console.error('Quest configuration not found in DOM');
    return;
  }

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (e) {
    console.error('Failed to parse Quest configuration:', e);
    return;
  }

  // Set window globals from configuration
  window.base_url = window.location.href;
  window.controller = config.controller;
  window.controller_path = '/' + config.controller + '/';
  window.controller_second = config.controller_second;
  window.action_name = config.action_name;
  window.timezone = config.timezone;
  window.template_path = config.template_path;
  window.page_title = config.page_title;
  window.side_nav = config.side_nav;
  window.hideSideNav = config.hideSideNav;
  window.use_vue3_chrome = config.use_vue3_chrome;
  window.timezone_at_quest = config.timezone_at_quest;

  // User permission flags (if user is logged in)
  if (config.user) {
    window.is_systemadmin = config.user.is_systemadmin;
    window.is_institutionadmin = config.user.is_institutionadmin;
    window.is_learning_assistant = config.user.is_learning_assistant;
    window.is_limited_ta = config.user.is_limited_ta;
    window.is_ta = config.user.is_ta;
    window.is_editor = config.user.is_editor;
    window.is_instructor = config.user.is_instructor;
    window.c_loop = config.user.c_loop;
    window.logBrowserevent = config.user.logBrowserevent;
  }

  // Instance view mode
  window.instance_view = config.instance_view;

  // Timeout settings
  window.lastConnect = new Date();
  window.timeoutMinutes = config.timeoutMinutes;

  // Legacy compatibility: Create global variables for inline scripts
  window.controller = window.controller;
  window.controller_second = window.controller_second;
  window.action_name = window.action_name;
  window.template_path = window.template_path;
  window.timezone = window.timezone;

  console.log('Quest configuration loaded:', config.controller, config.action_name);
}

// Load immediately - Vite modules execute after DOM is parsed,
// so the config element is already available. No DOMContentLoaded needed.
loadQuestConfig();
